module.exports = __webpack_public_path__ + "media/images/icons/without_regulatory_demands-96a8a3cce5d76b142c0bd21fb914e597.svg";